module.exports = __webpack_public_path__ + "badc2811e66690369c325e101deb9871.pdf";